import { render } from "./paymentTypePopup.vue?vue&type=template&id=5cba283e"
import script from "./paymentTypePopup.vue?vue&type=script&lang=js"
export * from "./paymentTypePopup.vue?vue&type=script&lang=js"

import "./paymentTypePopup.vue?vue&type=style&index=0&id=5cba283e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__